import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoaderService } from './loader.service';
import { MessageService } from './message.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class LensDispatchLoginService {
  constructor(public http: HttpClient
    , private messageService: MessageService
    , private loaderService: LoaderService
    , public router: Router) { }

  subscriptions: Subscription[] = []

  lensdispatchLogin(shopId: string) {

    



    this.loaderService.emitChange(true);

    let myPost = { "Shop": shopId }
      this.subscriptions.push(this.http.post('/LensDispatch/LensDispatchLoginTokenGet', myPost)
        .subscribe((result: any) => {

          this.loaderService.emitChange(false);
          if (!result) {
            this.messageService.emitChange({ "Message": "No data", "Css": "error" });
          }
          else if (result.error) {
            this.messageService.emitChange({ "Message": result.error, "Css": "error" });
          }
          else {

            const mapForm = document.createElement('form');
            mapForm.method = 'POST';
            mapForm.action = result.LensDispatchLocation;
            mapForm.target = 'LensDispatch'; // open in new tab
            mapForm.style.display = 'none';

            const mapInput = document.createElement('input');
            mapInput.type = 'hidden';
            mapInput.name = 'Token';
            mapInput.value = result.Token;

            const mapInputReplyUrl = document.createElement('input');
            mapInputReplyUrl.type = 'hidden';
            mapInputReplyUrl.name = 'ReplyUrl';
            mapInputReplyUrl.value = result.ReplyUrl;

            const mapInputProvider = document.createElement('input');
            mapInputProvider.type = 'hidden';
            mapInputProvider.name = 'Provider';
            mapInputProvider.value = result.Provider;

            mapForm.appendChild(mapInput);
            mapForm.appendChild(mapInputReplyUrl);
            mapForm.appendChild(mapInputProvider);
            document.body.appendChild(mapForm);


            const target = new Date('2026-03-17T13:30:00Z');
            const now = new Date();

            //if (now > target || shopId.toUpperCase() == 'FF935A8F-5469-4680-9311-A7CF1393A5A6') {
              mapForm.submit();
            //} else {
            //  this.router.navigate(['/shop/trakii']);
            //}

            document.body.removeChild(mapForm);

          }
        }, error => {
          this.messageService.emitChange({ "Message": error, "Css": "error" });
        })
      )

    }





}
